export default __webpack_public_path__ + "static/media/whatsappIconWhite.d825493d.svg";